/**
 * Типы элементов заловка страницы (типичные).
 * @publicApi
 */
export enum DxPageHeaderItemType {
  APP_LOGO = 'APP_LOGO',
  APP_NAME = 'APP_NAME',
  TOOL_BUTTON = 'TOOL_BUTTON',
  COMBO = 'COMBO',
  NAVIGATION_BAR = 'NAVIGATION_BAR',
  USER_BAR = 'USER_BAR',
  HELP_BAR = 'HELP_BAR',
  SETTINGS_BAR = 'SETTINGS_BAR',
  NOTIFICATION_BAR = 'NOTIFICATION_BAR',
  LOGOUT_BAR = 'LOGOUT_BAR',
  SPACER = 'SPACER'
}
